<template>
  <form
    class="condition-report-request-form"
    ref="conditionReportRequestForm"
    @submit.stop.prevent="$emit('submit')"
  >
    <div class="condition-report-request-form-lot-info">
      <div class="condition-report-request-form-lot-image-wrapper">
        <b-img
          v-if="lot.image_urls.length"
          :src="lot.image_urls[0]"
          :alt="$options.filters.stripTags($options.filters.currentLocale(lot.title))"
          fluid
        />
        <b-img v-else src="https://cdn.artisio.co/no_image.jpg" fluid/>
      </div>
      <lot-no :lot="lot"/>
      <h5 class="font-weight-bold condition-report-request-form-lot-title">{{title}}</h5>
    </div>
    <div v-if="!is_authorized">
      <InputWidget
        :label="$t('First Name')"
        type="text"
        v-model="firstName"
        rules="required"
      />
      <InputWidget
        :label="$t('Last Name')"
        type="text"
        v-model="lastName"
        rules="required"
      />
      <InputWidget
        :label="$t('Email Address')"
        type="email"
        v-model="email"
        rules="required|email"
      />
    </div>
    <InputWidget
      :label="$t('Message')"
      type="textarea"
      v-model="message"
      rules="required"
    />
  </form>
</template>

<script>
import {mapGetters, mapMutations, mapState} from "vuex";
import UpcomingAmountPopover from "../lot-view/UpcomingAmountPopover.vue";
import TaxRateAndPremiums from "@/components/TaxRateAndPremiums.vue";
import CalculatedPremium from "@/components/lot-view/CalculatedPremium.vue";
import BidAmount from "@/components/lot-view/BidAmount.vue";
import BidTotalAmount from "@/components/lot-view/BidTotalAmount.vue";
import MaxBidForm from "@/components/configuration/lot-list-item/MaxBidForm.vue";
import InputWidget from "@/components/core/InputWidget.vue";
import lotHelperMixin from "@/mixins/lotHelperMixin";
import {BImg} from "bootstrap-vue";

export default {
  name: "ConditionReportRequestForm",
  mixins: [lotHelperMixin],
  components: {
    BImg,
    InputWidget,
    MaxBidForm,
    BidTotalAmount,
    BidAmount,
    CalculatedPremium,
    TaxRateAndPremiums,
    UpcomingAmountPopover
  },
  props: {
    onSubmit: Function,
  },
  data: () => ({
    message: '',
    firstName: '',
    lastName: '',
    email: '',
  }),
  computed: {
    ...mapState({
      conditionReportModal: state => state.lotObject.conditionReportModal,
      lot: state => state.lotObject.data,
    }),
    ...mapGetters(['is_authorized']),
  },
  methods: {
    ...mapMutations(['setShowConditionReportModal']),
  }
}
</script>
